import {
  ACTIVATE_LAYER,
  APPLY_ALL_LAYERS_VISIBILITY,
  COMPOSITIONS_FETCH,
  DEACTIVATE_LAYERS,
  DECISION_FETCH,
  FEATURES_FETCH,
  FETCH_ALL_LAYERS,
  FETCH_BACKGROUND_LAYERS,
  LAYERS_DELETE,
  MAP_SELECTION_CLEAR,
  SET_GET_FEATURE_INFO_LAYER,
  STYLES_FETCH,
  TEMPORARY_LAYER_REMOVE,
  TOGGLE_ACTIVE_LAYER
} from './actions.type';

import {
  ADD_TEMPORARY_LAYER_TO_USER_LAYERS,
  FEATURES_LAYER_SET,
  FEATURES_SHOW_DESELECT,
  LAYERS_ADD_WMS_LAYER,
  LAYERS_ADD_WMTS_LAYER_SOURCE,
  LAYERS_LAYERS_ADD,
  LAYERS_LAYER_DELETE,
  LAYERS_LOADING_SET,
  MAP_HISTORY_DATA_MODE_SET,
  MEASUREMENTS_ENABLED_SET,
  SET_ALL_LAYERS,
  SET_LAYER_VISIBILITY,
  TOGGLE_LAYER_VISIBILITY_BY_ID,
  WINDOW_API_ERROR_SHOW,
  WINDOW_NOTIFICATION_SHOW
} from './mutations.type';

import ContextInstance from '../api/ContextInstance';
import { LayerTypes } from '../common/layerEnums';
import { getBasicGeometryType, setLayerProperty } from '../common/layersHelper';
import ResolutionHelper from '../common/resolutionHelper';
import MapLayerBuilder from '../models/MapLayerBuilder';

import { Api as ApiWarstwy } from '../api/api-warstwy';

const layerApi = new ApiWarstwy();

const initialState = {
  layers: [],
  layersLoading: false,
  confirmation: {
    message: '',
    yesAction: () => {},
    noAction: () => {}
  },
  showConfirmation: false,
  wmtsLayersSources: []
};

export const state = Object.assign({}, initialState);

async function createLayer(
  apiLayer,
  index,
  apiLayers,
  context,
  useStoredSettings
) {
  const layerTableMeta =
    context.getters.tableMeta.find(el => {
      return el.id === (apiLayer.parent_id || apiLayer.id);
    }) || null;

  const atributes =
    layerTableMeta && layerTableMeta.kolumny
      ? layerTableMeta.kolumny.map((y, i) => {
          const z = {};
          z.description = y.etykieta;
          z.isDateTimeField = false;
          z.key = y.nazwa;
          z.name = y.etykieta;
          z.read_only = false;
          z.type = 'string';
          z.visible = true;
          z.dictionary = [];
          z.not_in_mapping = true;
          z.displayed = true;
          // z.index = z.order = i;
          return z;
        })
      : [];
  // const oldAtributes = (apiLayer.pola || []).map((y, i) => {
  //   y.displayed = y.visible;
  //   y.index = y.order = i;
  //   return y;
  // });
  let currentStyle = apiLayer.styl || {};
  let defaultStyleId = currentStyle.id || '';

  const layer = {
    id: apiLayer.id,
    parentId: apiLayer.parent_id,
    order:
      apiLayer.grupa === 'kompozycji'
        ? undefined
        : apiLayers.length - 1 - index,
    names: apiLayer.warstwy || [],
    legends: [],
    url: (apiLayer.usluga || {}).adres,
    datasource: apiLayer.datasource,
    title: apiLayer.nazwa,
    isSystem: apiLayer.systemowa,
    isMvt: apiLayer.datasource ? apiLayer.datasource.startsWith('mvt_') : false,
    isAdministrative: apiLayer.administracyjna,
    type: apiLayer.typ,
    getFeatureInfoEnabled: apiLayer.typ == LayerTypes.wms,
    getReportingDemandEnabled: false,
    visible: false,
    styleId: defaultStyleId,
    defaultStyleId: defaultStyleId,
    createdStyleId: undefined,
    // attributes: (apiLayer.pola || []).map((y, i) => {
    //   y.displayed = y.visible;
    //   y.index = y.order = i;
    //   return y;
    // }),
    attributes: atributes,
    ownerId: apiLayer.wlasciciel,
    isDtm: apiLayer.is_dtm,
    readOnly: apiLayer.readonly,
    active: false,
    expanded: false,
    modified: false,
    view3d: false,
    atrybutNazwa: apiLayer.atrybut_nazwa,
    extent: apiLayer.extent,
    pointInThePast: undefined,
    scaleMax: apiLayer.skala_max,
    scaleMin: apiLayer.skala_min,
    basicGeometryType: getBasicGeometryType(apiLayer.typ_geometrii),
    snap: apiLayer.snap,
    hide: false,
    compositionId: apiLayer.kompozycja_id,
    copyright: apiLayer.copyright,
    isVisibleInResolution: function(resolution) {
      // null oznacza minimalną lub maksymalną możliwą rozdzielczość
      const mapHasHigherResThanMinLayer =
        this.scaleMin == null ||
        ResolutionHelper.getResolutionFromScale(this.scaleMin) <= resolution;
      const mapHasLowerResThanMaxLayer =
        this.scaleMax == null ||
        ResolutionHelper.getResolutionFromScale(this.scaleMax) >= resolution;
      return mapHasHigherResThanMinLayer && mapHasLowerResThanMaxLayer;
    },
    group: apiLayer.grupa
  };

  if (useStoredSettings) {
    layer.visible = Boolean(context.rootGetters.storedLayerVisible(layer.id));
    layer.styleId =
      context.rootGetters.storedLayerStyleId(layer.id) || defaultStyleId;
    currentStyle =
      (context.rootGetters.styles || []).find(x => x.id === layer.styleId) ||
      currentStyle;
  }

  let builder = new MapLayerBuilder(
    layer,
    currentStyle,
    context.getters.coordinateSystem
  );
  layer.mapLayer = await builder.getOlLayer(null, null, context);

  if (
    [
      LayerTypes.point,
      LayerTypes.linestring,
      LayerTypes.polygon,
      LayerTypes.geometry
    ].indexOf(layer.type) !== -1
  ) {
    builder = new MapLayerBuilder(
      layer,
      currentStyle,
      context.getters.coordinateSystem
    );
    layer.mapHighResolutionLayer = await builder.getOlLayer(
      true,
      false,
      context
    );
    layer.mapHistoricalLayer = await builder.getOlLayer(false, true, context);
  }

  return layer;
}
async function addWmsLayer(
  params
) {
  if (!params.type) params.type = 'wms';

  const layer = {
    id: params.url + '_' + (params.names ? params.names.split(',') : '_all_layers'),
    order: 999999999,
    names: params.names ? params.names.split(',') : [],
    legends: [],
    "url": params.url,
    datasource: null,
    title: params.title,
    isSystem: false,
    isAdministrative: false,
    type: (params.type == 'wmts' ? LayerTypes.wmts : LayerTypes.wmsgc),
    getFeatureInfoEnabled: true,
    getReportingDemandEnabled: false,
    visible: true,
    styleId: null,
    defaultStyleId: null,
    createdStyleId: undefined,

    attributes: [],
    ownerId: null,
    isDtm: false,
    readOnly: true,
    active: false,
    expanded: true,
    modified: false,
    view3d: false,
    atrybutNazwa: null,
    extent: null,
    pointInThePast: undefined,
    scaleMax: null,
    scaleMin: null,
    basicGeometryType: null,
    snap: false,
    hide: false,
    compositionId: null,
    copyright: null,
    isVisibleInResolution: function (resolution) {
      // null oznacza minimalną lub maksymalną możliwą rozdzielczość
      const mapHasHigherResThanMinLayer =
        this.scaleMin == null ||
        ResolutionHelper.getResolutionFromScale(this.scaleMin) <= resolution;
      const mapHasLowerResThanMaxLayer =
        this.scaleMax == null ||
        ResolutionHelper.getResolutionFromScale(this.scaleMax) >= resolution;
      return mapHasHigherResThanMinLayer && mapHasLowerResThanMaxLayer;
    },
    group: params.group ? params.group : "użytkownika"
  };

  let builder = new MapLayerBuilder(
    layer,
    null,
    undefined
  );
  layer.mapLayer = await builder.getOlLayer(null, null, undefined);

  if (layer.mapLayer) {
    if ((!Array.isArray(layer.names)) || (layer.names.length == 0)) layer.names = layer.mapLayer.names;
    if (!layer.title) layer.title = layer.mapLayer.title;
    if (!layer.extent) layer.extent = layer.mapLayer.extent;
  }
  return layer;
}

function rebuildLayersOrder(layers) {
  if (Array.isArray(layers)) {
    layers.forEach((layer, index, array) => {
      if (layer.group === 'podklad') {
        layer.order = 0 - array.length - 1 - index;
        if (layer.mapLayer && layer.mapLayer.setZIndex) {
          layer.mapLayer.setZIndex(layer.order);
        }
      } else if (layer.group !== 'kompozycji') {
        layer.order = array.length - 1 - index;
        if (layer.mapLayer && layer.mapLayer.setZIndex) {
          layer.mapLayer.setZIndex(layer.order);
        }

        if (
          layer.mapHighResolutionLayer &&
          layer.mapHighResolutionLayer.setZIndex
        ) {
          layer.mapHighResolutionLayer.setZIndex(layer.order);
        }

        if (layer.mapHistoricalLayer && layer.mapHistoricalLayer.setZIndex) {
          layer.mapHistoricalLayer.setZIndex(layer.order);
        }
      }
    });
  }
}

function getParamValueFromUrl(param) {
  var results = new RegExp('[?&]' + param + '=([^&#]*)').exec(
    window.location.href
  );
  if (results == null) {
    return null;
  } else {
    return decodeURI(results[1]) || 0;
  }
}

export const actions = {
  async [FETCH_ALL_LAYERS](context, { useStoredSettings }) {
    try {
      context.commit(LAYERS_LOADING_SET, true);
      await context.dispatch(STYLES_FETCH);

      const apiLayers = (
        await layerApi.getWarstwy({
          wso2_id: this.contextEmail ? this.contextEmail : null,
          orgid: this.contextOrganizationId ? this.contextOrganizationId : null,
          include_details: true,
          items_per_page: 1000,
          order_by: 'order',
          desc: false
        })
      ).body.warstwy;

      const backgroundLayers = apiLayers.filter(al => al.grupa === 'podklad');
      const compositionLayers = apiLayers.filter(
        al => al.grupa === 'kompozycji'
      );
      const userLayers = apiLayers.filter(al => al.grupa === 'użytkownika');
      const systemLayers = apiLayers.filter(al => al.grupa === 'infrastruktura_telekomunikacyjna');
      const pwidLayers = apiLayers.filter(al => al.grupa === 'plany_inwestycyjne');
      const archiveLayers = apiLayers.filter(al => al.grupa === 'archiwalne');
      const mvtLayers = apiLayers.filter(al => al.grupa === 'organizacji').map((al) => {return {...al, visible: false}});
      const layers = [];
      let allApiLayers = systemLayers
        .concat(mvtLayers)
        .concat(pwidLayers)
        .concat(archiveLayers)
        .concat(userLayers)
        .concat(backgroundLayers)
        .concat(compositionLayers);

      for (let i = 0; i < allApiLayers.length; i++) {
        try {
          const appLayer = await createLayer(
            allApiLayers[i],
            i,
            layers,
            context,
            useStoredSettings
          );
          layers.push(appLayer);
        } catch (error) {
          context.commit(WINDOW_NOTIFICATION_SHOW, {
            message: error,
            type: 'error',
            title: 'Uwaga.'
          });
        }
      }

      // const promises = allApiLayers.map(async (apiLayer, i) => {
      //   try {
      //     const appLayer = await createLayer(
      //       apiLayer,
      //       i,
      //       layers,
      //       context,
      //       useStoredSettings
      //     );
      //     layers.push(appLayer);
      //   } catch (error) {
      //     context.commit(WINDOW_NOTIFICATION_SHOW, {
      //       message: error,
      //       type: 'error',
      //       title: 'Uwaga.'
      //     });
      //   }
      // });

      // await Promise.all(promises);

      const layersNames = [
        {
          name: 'Infrastruktura techniczna - punktowa',
          newName:
            'Infrastruktura techniczna i kanały technologiczne - punktowa'
        },
        {
          name: 'Infrastruktura techniczna - liniowa',
          newName: 'Infrastruktura techniczna i kanały technologiczne - liniowa'
        },
        {
          name: 'Infrastruktura techniczna - powierzchniowa',
          newName:
            'Infrastruktura techniczna i kanały technologiczne - powierzchniowa'
        },
        {
          name: 'Roboty budowlane - infrastruktura punktowa',
          newName: 'Plany inwestycyjne – infrastruktura punktowa'
        },
        {
          name: 'Roboty budowlane - infrastruktura liniowa',
          newName: 'Plany inwestycyjne – infrastruktura liniowa'
        },
        {
          name: 'Roboty budowlane - infrastruktura powierzchniowa',
          newName: 'Plany inwestycyjne – infrastruktura powierzchniowa'
        }
      ];

      // layers.forEach(function(layer) {
      //   const hasNewName = layersNames.filter(x => x.name == layer.title);
      //   if (hasNewName.length > 0 && layer.isSystem) {
      //     layer.title = layersNames.filter(
      //       x => x.name == layer.title
      //     )[0].newName;
      //   }
      // });

      rebuildLayersOrder(layers);

      context.commit(SET_ALL_LAYERS, layers);

      await context.dispatch(COMPOSITIONS_FETCH, {
        userEmail: ContextInstance.state.email,
        useStoredSettings: useStoredSettings
      });
      await context.dispatch(FETCH_BACKGROUND_LAYERS);

      const decisionId = getParamValueFromUrl('decyzja');

      if (decisionId) {
        await context.dispatch(DECISION_FETCH, decisionId);
      }
    } catch (error) {
      context.commit(
        WINDOW_API_ERROR_SHOW,
        'Pobieranie warstw nie powiodło się. Proszę odświeżyć stronę.'
      );
    } finally {
      context.commit(LAYERS_LOADING_SET, false);
    }
  },
  [TOGGLE_ACTIVE_LAYER](
    { dispatch, commit, getters, rootGetters },
    { layer, dontToggleIfActive }
  ) {
    if (getters.layers.some(l => l.active)) {
      if (dontToggleIfActive) {
        const currentlyActiveLayer = getters.layers.find(l => l.active);
        if (currentlyActiveLayer == layer) return;
      }

      state.confirmation.noAction = function() {
        state.showConfirmation = false;
      };

      if (layer.active && rootGetters.isHistoryDataMode) {
        state.confirmation.message =
          'Wyłączenie warstwy aktywnej spowoduje powrót do przeglądania danych aktualnych. Czy chcesz kontynuować?';
        state.confirmation.yesAction = function() {
          commit(MAP_HISTORY_DATA_MODE_SET, false);
          dispatch(ACTIVATE_LAYER, layer);
          commit(WINDOW_NOTIFICATION_SHOW, {
            message: 'Zmiany zostały zapisane.',
            title: 'Sukces.',
            type: 'success',
            duration: 5000
          });
          state.showConfirmation = false;
        };

        state.showConfirmation = true;

        return;
      }

      if (rootGetters.features.length) {
        state.confirmation.message =
          'Czy na pewno chcesz zmienić warstwę aktywną?';
        state.confirmation.yesAction = function() {
          commit(FEATURES_SHOW_DESELECT);
          dispatch(MAP_SELECTION_CLEAR);
          dispatch(ACTIVATE_LAYER, layer);
          commit(WINDOW_NOTIFICATION_SHOW, {
            message: 'Zmiany zostały zapisane.',
            title: 'Sukces.',
            type: 'success',
            duration: 5000
          });
          state.showConfirmation = false;
        };

        state.showConfirmation = true;
        return;
      }

      dispatch(ACTIVATE_LAYER, layer);
    } else {
      if (rootGetters.getFeatureSelectedLayer) {
        dispatch(SET_GET_FEATURE_INFO_LAYER, null);

        commit(WINDOW_NOTIFICATION_SHOW, {
          type: 'warn',
          title: 'Uwaga. Automatycznie wyłączono warstwę do odczytu.',
          message:
            'Odczyt informacji na jednej z warstw był włączony. Wybranie warstwy aktywnej wyłącza odczyt na wszystkich innych warstwach.'
        });
      }

      dispatch(ACTIVATE_LAYER, layer);
    }
  },
  [ACTIVATE_LAYER]({ commit, dispatch, getters }, layer) {
    getters.layers.forEach(function(item) {
      if (item.id !== layer.id) {
        item.active = false;
      }
    });

    layer.active = !layer.active;

    if (!layer.visible) {
      layer.mapLayer.setVisible(layer.visible);

      if (layer.mapHighResolutionLayer) {
        layer.mapHighResolutionLayer.setVisible(layer.visible);
      }
    }

    commit(FEATURES_LAYER_SET, layer.active ? layer : undefined);
    dispatch(FEATURES_FETCH, { _this: this, pageNumber: 1, pageSize: 200 });
  },
  [DEACTIVATE_LAYERS]({ commit, rootGetters }) {
    commit(MAP_HISTORY_DATA_MODE_SET, false);
    rootGetters.layers.forEach(item => {
      item.active = false;
    });
    commit(FEATURES_LAYER_SET, undefined);
  },
  [TEMPORARY_LAYER_REMOVE]({ state, commit }, layer) {
    commit(MEASUREMENTS_ENABLED_SET, false);

    const layerIndex = state.layers.indexOf(layer);

    if (layerIndex >= 0) {
      state.layers.splice(layerIndex, 1);
      rebuildLayersOrder(state.layers);
    }
  },
  async [LAYERS_DELETE](context, layer) {
    try {
      await layerApi.deleteWarstwyById({
        wso2_id: this.contextEmail ? this.contextEmail : null,
        orgid: this.contextOrganizationId ? this.contextOrganizationId : null,
        id: layer.id
      });

      context.commit(WINDOW_NOTIFICATION_SHOW, {
        type: 'success',
        title: 'Sukces',
        message: 'Warstwa została usunięta.'
      });

      context.commit(LAYERS_LAYER_DELETE, layer);
    } catch (error) {
      context.commit(WINDOW_API_ERROR_SHOW, error);
    }
  },
  async [APPLY_ALL_LAYERS_VISIBILITY](context) {
    context.rootGetters.layers.forEach(x => {
      x.mapLayer.setVisible(x.visible);

      if (x.mapHighResolutionLayer) {
        x.mapHighResolutionLayer.setVisible(x.visible);
      }
    });
  }
};

export const mutations = {

  async [LAYERS_ADD_WMS_LAYER](state,params){
	const layer = await addWmsLayer(params);
	if((state) && (layer)){
		if(Array.isArray(state.layers)){
			state.layers.splice(0,0,layer);
		} else {
			state.layers = [layer];
		}
    rebuildLayersOrder(state.layers);
	}
  },
  [SET_ALL_LAYERS](state, layers) {
    for (var i = 0; i < layers.length; ++i) {
      let id = layers[i].id;
      let tempLayer = state.layers.find(x => x.id == id);

      if (tempLayer) {
        layers[i].visible = tempLayer.visible;
        layers[i].mapLayer.setVisible(tempLayer.visible);

        if (layers[i].mapHighResolutionLayer) {
          layers[i].mapHighResolutionLayer.setVisible(tempLayer.visible);
        }
      }
    }

    state.layers = layers;
  },
  [TOGGLE_LAYER_VISIBILITY_BY_ID](state, layerId) {
    const layer = state.layers.find(layer => layer.id == layerId);

    if (layer) {
      setLayerProperty(layer, 'visible', !layer.visible);
      layer.mapLayer.setVisible(layer.visible);

      if (layer.mapHighResolutionLayer) {
        layer.mapHighResolutionLayer.setVisible(layer.visible);
      }
    }
  },
  [SET_LAYER_VISIBILITY](state, { layerId, visible }) {
    const layer = state.layers.find(layer => layer.id == layerId);

    if (layer) {
      setLayerProperty(layer, 'visible', visible);
      layer.mapLayer.setVisible(layer.visible);

      if (layer.mapHighResolutionLayer) {
        layer.mapHighResolutionLayer.setVisible(layer.visible);
      }
    }
  },
  [ADD_TEMPORARY_LAYER_TO_USER_LAYERS](state, layer) {
    layer.group = 'tymczasowa';
    let maxIndex = 0;
    const anyLayerIsUserTab = state.layers.some(
      layer => layer.group === 'użytkownika' || layer.group === 'tymczasowa'
    );

    if (anyLayerIsUserTab) {
      maxIndex = state.layers
        .filter(
          layer => layer.group === 'użytkownika' || layer.group === 'tymczasowa'
        )
        .reduce((maxIndex, layer) => {
          const index = state.layers.indexOf(layer);
          return index > maxIndex ? index : maxIndex;
        }, 0);
    } else {
      maxIndex = state.layers
        .filter(layer => layer.group === 'systemowa')
        .reduce((maxIndex, layer) => {
          const index = state.layers.indexOf(layer);
          return index > maxIndex ? index : maxIndex;
        }, 0);
    }

    const indexForTemporaryLayer =
      maxIndex === state.layers.length - 1 ? maxIndex : maxIndex + 1;
    const newLayers = state.layers
      .slice(0, indexForTemporaryLayer)
      .concat([
        layer,
        ...state.layers.slice(indexForTemporaryLayer + 1, state.layers.length)
      ]);
    rebuildLayersOrder(newLayers);
    state.layers = newLayers;
  },
  [LAYERS_LAYERS_ADD](state, layers) {
    state.layers = [...state.layers, ...layers];
    rebuildLayersOrder(state.layers);
  },
  [LAYERS_LAYER_DELETE](state, layer) {
    state.layers = state.layers.filter(x => x.id !== layer.id);
    rebuildLayersOrder(state.layers);
  },
  [LAYERS_LOADING_SET](state, value) {
    state.layersLoading = value;
  },
  [LAYERS_ADD_WMTS_LAYER_SOURCE](state, source) {
    state.wmtsLayersSources.push({ ...source });
  }
};

const getters = {
  layers: state => state.layers,
  activeLayer: state => state.layers.find(layer => layer.active),
  systemLayers: state =>
    state.layers.filter(layer => layer.group === 'infrastruktura_telekomunikacyjna'),
  pwidLayers: state => state.layers.filter(layer => layer.group === 'plany_inwestycyjne'),
  archiveLayers: state =>
    state.layers.filter(layer => layer.group === 'archiwalne'),
  compositionGroupLayers: state =>
    state.layers.filter(layer => layer.group === 'kompozycji'),
  userGroupLayers: state =>
    state.layers.filter(
      layer => layer.group === 'użytkownika' || layer.group === 'tymczasowa'
    ),
  mvtLayers: state =>
    state.layers.filter(layer => layer.group === 'organizacji'),
  backgroundGroupLayers: state =>
    state.layers.filter(layer => layer.group === 'podklad'),
  temporaryLayers: state =>
    state.layers.filter(layer => layer.group === 'tymczasowa'),
  visibleTemporaryLayers: state =>
    state.layers.filter(layer => layer.group === 'tymczasowa' && layer.visible),
  layersLoading: state => state.layersLoading,
  confirmation: state => state.confirmation,
  showConfirmationModal: state => state.showConfirmation,
  maxZIndex: state => {
    if (state.layers.length == 0) {
      return 1;
    }

    const zIndexes = state.layers.map(function(layer) {
      if (layer.mapHighResolutionLayer != undefined) {
        return layer.mapHighResolutionLayer.getZIndex() || 0;
      }

      if (layer.mapLayer != undefined) {
        return layer.mapLayer.getZIndex() || 0;
      }

      return 0;
    });

    return Math.max(...zIndexes);
  },
  wmtsLayersSources: state => state.wmtsLayersSources
};

export default {
  state,
  actions,
  mutations,
  getters
};
